import React, {useCallback, useEffect, useState} from 'react';
import DatePicker, {registerLocale} from "react-datepicker";
import ru from "date-fns/locale/ru";
import en from "date-fns/locale/en-US";

const locale = window.locale

if (locale === 'ru') {
    registerLocale('ru', ru);
} else {
    registerLocale('en', en);
}


function ProfitGraphHeader(props) {
    const classPrefix = props.classPrefix
    const timeFrom = props.timeFrom
    const timeTo = props.timeTo
    const timeFromMax = props.timeFromMax
    const timeToMax = props.timeToMax
    const profit = props.profit
    const profitCurr = props.profitCurr
    const profitPercent = props.profitPercent
    const updateTimeFrom = props.updateTimeFrom
    const updateTimeTo = props.updateTimeTo

    const headerTextPeriodFrom = window.jsTranslations.headerTextPeriodFrom
    const headerTextPeriodTo = window.jsTranslations.headerTextPeriodTo
    const headerTextSummary = window.jsTranslations.headerTextSummary

    const translate = props.translate

    const dateFormat = 'dd.MM.yyyy'

    return <div className={`${classPrefix}__header`}>
        <div className={`${classPrefix}__header-dates`}>
            <div className={`${classPrefix}__header-dates-text`}>{headerTextPeriodFrom}</div>
            <div className={`${classPrefix}__header-dates-input custom-datepicker`}>
                <DatePicker
                    selected={timeFrom ? timeFrom : timeFromMax}
                    onChange={(date) => updateTimeFrom(+date)}
                    className="custom-datepicker__input"
                    locale={locale}
                    dateFormat={dateFormat}
                    minDate={timeFromMax}
                    maxDate={timeToMax}
                />
            </div>

            <div className={`${classPrefix}__header-dates-text`}>{headerTextPeriodTo}</div>

            <div className={`${classPrefix}__header-dates-input custom-datepicker`}>
                <DatePicker
                    selected={timeTo ? timeTo : timeToMax}
                    onChange={(date) => updateTimeTo(+date)}
                    className="custom-datepicker__input"
                    locale={locale}
                    dateFormat={dateFormat}
                    minDate={timeFromMax}
                    maxDate={timeToMax}
                />
            </div>

        </div>
        <div className={`${classPrefix}__header-info`}>
            <div className={`${classPrefix}__header-info-text`}>{headerTextSummary}:</div>
            <div className={`${classPrefix}__header-info-value`}>{profit} {profitCurr} ({profitPercent}%)</div>
        </div>
    </div>;
}

export default ProfitGraphHeader;